import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';
import { Link } from 'react-router-dom';

export default function NoCommission() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="零仲介費租屋說明｜台灣租房省仲介費完整指南 - 藍舍AI地產"
        description="藍舍AI地產完全零仲介費，台灣六都屋主直租，台北、新北、桃園、台中、台南、高雄房源免手續費直聯屋主。傳統仲介費 vs 藍舍費用完整對比，月租25,000元可省下25,000元仲介費。"
        keywords="免仲介費租屋,零仲介費,屋主直租,省仲介費,台北免仲介費,新北免仲介費,台中免仲介費,高雄免仲介費,租房省錢,不用仲介租房,直租平台台灣,租屋零手續費"
        canonical="/no-commission"
        lastModified="2026-03-18"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "零仲介費租屋說明 - 藍舍AI地產",
            "url": `${import.meta.env.VITE_SITE_URL || 'https://ailanshe.com'}/no-commission`,
            "description": "了解藍舍AI地產如何幫您省下高額仲介費，屋主直租零手續費",
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {"@type": "ListItem", "position": 1, "name": "首頁", "item": `${import.meta.env.VITE_SITE_URL || 'https://ailanshe.com'}/`},
                {"@type": "ListItem", "position": 2, "name": "零仲介費說明", "item": `${import.meta.env.VITE_SITE_URL || 'https://ailanshe.com'}/no-commission`}
              ]
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "平台真的完全免費嗎？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "是的，藍舍AI地產平台目前在測試期間對屋主和租客均免費開放使用。不收取任何仲介費或服務費，目標是讓租房回歸簡單，讓屋主和租客能夠直接溝通。平台保留未來調整服務方案的權利。"
                }
              },
              {
                "@type": "Question",
                "name": "使用藍舍AI地產可以省多少仲介費？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "以月租25,000元為例，傳統租房需支付押金25,000元加仲介費25,000元，共50,000元。使用藍舍AI地產只需支付押金25,000元，完全省下25,000元仲介費。"
                }
              },
              {
                "@type": "Question",
                "name": "屋主直租的流程是什麼？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "只需三步：免費註冊帳號、選擇屋主身份後發布房源資訊（AI自動撰稿），租客即可搜尋並直接聯繫您，完全省去仲介費。"
                }
              },
              {
                "@type": "Question",
                "name": "房源資訊可靠嗎？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "我們會審核發布的房源資訊，如發現虛假或違規內容會予以移除。同時鼓勵用戶舉報可疑房源。惟平台目前仍在測試階段，建議用戶自行查核房源真實性。"
                }
              }
            ]
          }
        ]}
      />
      <Navbar />

      {/* ── 測試版聲明橫幅 ── */}
      <div className="bg-amber-50 border-b border-amber-200 mt-14 md:mt-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-3 flex items-start gap-3">
          <i className="ri-information-line text-amber-500 text-lg flex-shrink-0 mt-0.5"></i>
          <p className="text-xs md:text-sm text-amber-800 leading-relaxed">
            <strong>測試版公告：</strong>本平台目前處於測試（Beta）階段，所有功能均為試營運性質，服務內容、條款及收費方式可能隨時調整。平台不對房源資訊之真實性、完整性或準確性作出保證，使用者應自行查核並承擔相關風險。本平台不介入任何租賃糾紛，亦不承擔租賃契約之任何法律責任。
          </p>
        </div>
      </div>

      {/* Hero Section */}
      <div className="relative h-48 md:h-72 flex items-end overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/8e7dcdf02e9b0e0df794e3533ac51395.jpg"
          alt="免仲介說明背景"
          className="hidden md:block absolute inset-0 w-full h-full object-cover object-top"
        />
        {/* 手機版純色背景 */}
        <div className="md:hidden absolute inset-0 bg-teal-700" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/30 to-black/65"></div>
        <div className="relative z-10 w-full pb-8 md:pb-12">
          <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-6xl font-black text-white mb-2 md:mb-4 drop-shadow-lg">免仲介說明</h1>
            <p className="text-sm md:text-xl text-white/90 leading-relaxed drop-shadow">
              了解我們如何幫助您省下高額仲介費<br className="hidden md:block" />
              讓租房變得更簡單、更透明、更經濟
            </p>
          </div>
        </div>
      </div>

      <div className="pb-16 md:pb-20">
        <div className="max-w-5xl mx-auto px-4 md:px-6 pt-10 md:pt-16">

          {/* 傳統 vs 我們 — 手機單欄，桌面2欄 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 mb-12 md:mb-20">
            <div className="bg-red-50 rounded-3xl p-6 md:p-8">
              <div className="text-center mb-5 md:mb-6">
                <i className="ri-close-circle-line text-4xl md:text-5xl text-red-500 mb-2 md:mb-3"></i>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">傳統租房方式</h3>
              </div>
              <ul className="space-y-3 md:space-y-4">
                {[
                  '需支付一個月租金作為仲介費',
                  '無法直接與房東溝通',
                  '資訊不透明，可能有隱藏費用',
                  '流程繁瑣，耗時較長',
                  '可能遇到虛假房源',
                ].map((text, i) => (
                  <li key={i} className="flex items-start gap-3 text-gray-700 text-sm md:text-base">
                    <i className="ri-close-line text-red-500 mt-0.5 flex-shrink-0"></i>
                    <span>{text}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-teal-50 rounded-3xl p-6 md:p-8">
              <div className="text-center mb-5 md:mb-6">
                <i className="ri-check-double-line text-4xl md:text-5xl text-teal-500 mb-2 md:mb-3"></i>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">藍舍AI地產</h3>
              </div>
              <ul className="space-y-3 md:space-y-4">
                {[
                  ['測試期間免費', '，零仲介費'],
                  ['直接與房東聯繫溝通', ''],
                  ['資訊完全透明，藍舍AI地產平台', ''],
                  ['流程簡單快速，省時省力', ''],
                  ['AI 輔助審核房源', '，提升可信度'],
                ].map(([bold, rest], i) => (
                  <li key={i} className="flex items-start gap-3 text-gray-700 text-sm md:text-base">
                    <i className="ri-check-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                    <span>{rest ? <><strong>{bold}</strong>{rest}</> : bold}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* 費用對比 */}
          <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-3xl p-6 md:p-12 text-white mb-12 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-12">費用對比</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-12">
              <div className="text-center">
                <p className="text-sm md:text-lg mb-3 md:mb-4 opacity-90">傳統租房（月租25,000元）</p>
                <div className="bg-white/20 rounded-2xl p-5 md:p-8 backdrop-blur-sm">
                  <div className="text-3xl md:text-5xl font-black mb-1 md:mb-2">NT$ 50,000</div>
                  <p className="text-xs md:text-sm opacity-80">押金 + 仲介費</p>
                  <div className="mt-4 md:mt-6 text-left space-y-2 text-xs md:text-sm">
                    <div className="flex justify-between">
                      <span>押金（2個月）</span>
                      <span>NT$ 25,000</span>
                    </div>
                    <div className="flex justify-between">
                      <span>仲介費（1個月）</span>
                      <span className="text-red-300">NT$ 25,000</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <p className="text-sm md:text-lg mb-3 md:mb-4 opacity-90">藍舍AI地產（月租25,000元）</p>
                <div className="bg-white/20 rounded-2xl p-5 md:p-8 backdrop-blur-sm">
                  <div className="text-3xl md:text-5xl font-black mb-1 md:mb-2">NT$ 25,000</div>
                  <p className="text-xs md:text-sm opacity-80">僅需押金</p>
                  <div className="mt-4 md:mt-6 text-left space-y-2 text-xs md:text-sm">
                    <div className="flex justify-between">
                      <span>押金（2個月）</span>
                      <span>NT$ 25,000</span>
                    </div>
                    <div className="flex justify-between">
                      <span>仲介費</span>
                      <span className="text-green-300">NT$ 0</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center mt-6 md:mt-8">
              <div className="inline-block bg-white/20 rounded-full px-6 md:px-8 py-2.5 md:py-3 backdrop-blur-sm">
                <span className="text-lg md:text-2xl font-bold">省下 NT$ 25,000 仲介費！</span>
              </div>
            </div>
          </div>

          {/* 如何運作 — 手機單欄，桌面3欄 */}
          <div className="mb-12 md:mb-20">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-8 md:mb-12">如何運作</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
              {[
                { num: '1', title: '屋主發布房源', desc: '屋主在平台上免費發布房源資訊，包含照片、價格、地點等詳細資料' },
                { num: '2', title: '租客瀏覽搜尋', desc: '租客可以自由瀏覽所有房源，使用篩選功能找到符合需求的房子' },
                { num: '3', title: '直接聯繫溝通', desc: '租客直接聯繫屋主，約看房、談條件，完全不需要透過仲介' },
              ].map((item) => (
                <div key={item.num} className="text-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                    <span className="text-2xl md:text-3xl font-black text-teal-600">{item.num}</span>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 常見問題 */}
          <div className="mb-12 md:mb-20">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-8 md:mb-12">常見問題</h2>
            <div className="space-y-4 md:space-y-6">
              {[
                {
                  q: '平台真的完全免費嗎？',
                  a: '目前平台處於測試（Beta）階段，屋主與租客均免費使用，不收取仲介費或服務費。測試期間結束後，平台保留調整服務方案的權利，屆時將另行公告。',
                },
                {
                  q: '房源資訊可靠嗎？',
                  a: '我們會透過 AI 輔助審核發布的房源內容，如發現違規或不實資訊將予以移除。惟平台目前仍為測試性質，無法完全保證每筆房源的真實性，建議租客在實際看房時自行查核，並保持謹慎。',
                },
                {
                  q: '如何保障交易安全？',
                  a: '我們建議雙方在簽約前仔細確認房源資訊，並簽訂正式的租賃合約。看房時請注意安全，建議白天前往並告知親友。本平台不介入任何租賃糾紛，如有法律問題請尋求專業法律協助。',
                },
                {
                  q: '平台目前有哪些限制？',
                  a: '由於目前為測試階段，部分功能仍在持續開發與優化中，服務穩定性無法完全保證。平台不對因系統異常、資料遺失或服務中斷所造成的任何損失負責。建議用戶在重要事項上保留必要的備份與紀錄。',
                },
              ].map((item, i) => (
                <div key={i} className="bg-stone-50 rounded-2xl p-5 md:p-8">
                  <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3 flex items-center gap-2 md:gap-3">
                    <i className="ri-question-line text-teal-500 flex-shrink-0"></i>
                    {item.q}
                  </h4>
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed pl-6 md:pl-10">{item.a}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="text-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-3xl p-8 md:p-12 text-white">
            <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">準備好開始了嗎？</h2>
            <p className="text-base md:text-lg mb-6 md:mb-8 opacity-90">加入我們，體驗零仲介費的租房新方式</p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
              <Link
                to="/regions"
                className="px-8 md:px-10 py-3 md:py-4 bg-white text-teal-600 rounded-full font-bold text-base md:text-lg hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
              >
                開始找房
              </Link>
              <Link
                to="/publish"
                className="px-8 md:px-10 py-3 md:py-4 bg-transparent border-2 border-white text-white rounded-full font-bold text-base md:text-lg hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                發布房源
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
